import React, { FC } from 'react'
import { List } from 'phosphor-react'
import { resolveURL } from '@/lib/routes'
import { ImageAsset } from '@/types/site.interface'
import { Popover } from '@headlessui/react'
import { SocialLinks } from '../elements/social-links'
import { SocialLink } from '../elements/social-links.interface'
import { SiteLogo } from '../molecules/site-logo'
import { GenericFlyoutMenu } from './generic-flyout-menu'
import { GenericHeaderMobile } from './generic-header-mobile'
import { MenuProps } from './menu.interface'
import { NavigationItem } from './navigation-item'
import { NavigationList } from './navigation-list'

const MobileBurger = () => (
  <div className="-mr-2 flex items-center md:hidden">
    <Popover.Button className="focus-ring-inset inline-flex items-center justify-center rounded-md p-2 text-text hover:text-primary focus:outline-none">
      <span className="sr-only">Open main menu</span>
      <List className="h-8 w-8" aria-hidden="true" />
    </Popover.Button>
  </div>
)

interface Header {
  menuMobilePrimary?: MenuProps
  menuDesktopPrimary?: MenuProps
  menuMobileSecondary?: MenuProps
  menuDesktopSecondary?: MenuProps
  socialLinks?: SocialLink[]
  siteLogo?: ImageAsset
  enableShadow?: boolean
  siteName?: string
}

const GenericHeader: FC<Header> = ({
  menuDesktopPrimary,
  menuMobilePrimary,
  menuMobileSecondary,
  socialLinks,
  siteLogo,
  enableShadow,
  siteName,
}) => {
  return (
    <Popover as="header" className="relative z-10">
      {enableShadow && <div className="pointer-events-none absolute inset-1 z-60 shadow-lg" aria-hidden="true" />}
      <div className="bg-white">
        <div className="relative mx-auto flex max-w-3xl items-center justify-between px-4 sm:px-6" aria-label="Global">
          <div className="flex flex-1 items-center">
            <div className="flex w-full items-center justify-between md:w-auto">
              <SiteLogo siteLogo={siteLogo} siteName={siteName} />
              <MobileBurger />
            </div>
            <NavigationList>
              {menuDesktopPrimary?.items?.map((item, index) => {
                return item.flyout ? (
                  <GenericFlyoutMenu key={`k-${index}-${item.id}`} title={item.title} items={item.dropdownItems} />
                ) : (
                  <NavigationItem key={`k-${index}-${item.id}`} title={item.title} href={resolveURL(item)} />
                )
              })}
            </NavigationList>
          </div>
          <div className="hidden md:flex space-x-6">{socialLinks && <SocialLinks socialLinks={socialLinks} />}</div>
        </div>
      </div>
      <GenericHeaderMobile
        menuMobilePrimary={menuMobilePrimary}
        menuMobileSecondary={menuMobileSecondary}
        socialLinks={socialLinks}
        siteLogo={siteLogo}
        siteName={siteName}
      />
    </Popover>
  )
}

export default GenericHeader
